"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class PaymentMethodService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetch(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                console.log(payload);
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'hotel_billing/payment_method/list?outlet_id=' + payload.outlet_id + '&page=' + payload.pageNumber + '&limit=' + payload.limit;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                    validateStatus: function (status) {
                        if (status == 404) {
                            return true;
                        }
                        return status >= 200 && status < 300;
                    },
                });
                console.log(response.data);
                const responseData = response.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error("Failed to fetch payment method");
            }
        });
    }
    create(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'hotel_billing/payment_method/create';
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.post(url, payload, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                return response;
            }
            catch (err) {
                console.log("Error: ", err);
                throw err.response.data.message;
            }
        });
    }
    update(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'hotel_billing/payment_method/edit';
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.put(url, payload, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                return response;
            }
            catch (err) {
                throw new Error("Failed to update payment method");
            }
        });
    }
    bulk_save(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'hotel_billing/payment_method/bulk/create';
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.post(url, payload, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                return response;
            }
            catch (err) {
                throw new Error("Failed to update payment method");
            }
        });
    }
    create_default(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'hotel_billing/payment_method/create/default?outlet_id=' + payload;
                const response = yield axios_1.default.post(url, {}, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                return response;
            }
            catch (err) {
                throw new Error("Failed to create default payment method");
            }
        });
    }
}
exports.PaymentMethodService = PaymentMethodService;
